import httpClient from '@/libs/http-client'

export function getCashTransLogV2 (params) {
  const url = '/api/v2/retail/cashTransLog'
  return httpClient.post(url, params).then(response => {
    return response
  })
}
